/**
 * User Service
 * [2.11 FIX] Tüm `any` parametreler User tipine bağlandı, dönüş tipleri eklendi.
 */

import http from "./http";
import type { User } from "../types/user";
import type { KullaniciIslemTipi, GirisHataNedeni } from "../shared/constants/kullanici";

const apiEndpoint = "/api/users";

// Davetle hesap açma: admin yalnız ad, e-posta ve rol girer, şifre yazmaz. Sunucu şeması
// bilinmeyen alanı reddeder; gövdeye başka alan koyma.
export type CreateUserPayload = Pick<User, 'ad' | 'email' | 'rol'>;
export type UpdateUserPayload = Partial<Pick<User, 'ad' | 'email' | 'rol' | 'aktif_mi'>>;

/** Oluşturma ve adres düzeltmenin cevabı: davet denendiyse gönderilip gönderilmediği. */
export type DavetliKullaniciCevabi = User & { davetGonderildi?: boolean };

export const getUsers = (params?: { includeInactive?: boolean }) =>
  http.get<User[]>(apiEndpoint, { params });

export const getUser = (id: string | number) =>
  http.get<User>(`${apiEndpoint}/${id}`);

export const registerUser = (user: CreateUserPayload) =>
  http.post<DavetliKullaniciCevabi>(apiEndpoint, user);

export const updateUser = (id: string | number, user: UpdateUserPayload) =>
  http.put<DavetliKullaniciCevabi>(`${apiEndpoint}/${id}`, user);

/** Daveti yeniden gönderir; yeni bağlantı eskisini geçersiz kılar. */
export const davetiYenidenGonder = (id: string) =>
  http.post<{ message: string }>(`${apiEndpoint}/${id}/davet`);

/** Daveti iptal eder; hesap pasife alınır. */
export const davetiIptalEt = (id: string) =>
  http.delete<{ message: string }>(`${apiEndpoint}/${id}/davet`);

export const deleteUser = (id: string | number) =>
  http.delete<{ message: string }>(`${apiEndpoint}/${id}`);

export const unlockUser = async (id: string): Promise<void> => {
  await http.post(`${apiEndpoint}/${id}/unlock`);
};

export const uploadAvatar = (id: string | number, file: File) => {
  const formData = new FormData();
  formData.append('avatar', file);
  return http.post<{ success: boolean; profil_url: string }>(
    `${apiEndpoint}/${id}/upload-avatar`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
};

// ─── Faz 4: Login geçmişi ve audit log ─────────────────────────────────────

export interface LoginHistoryEntry {
  id: string;
  ip_adresi: string | null;
  user_agent: string | null;
  basarili: boolean;
  hata_nedeni: GirisHataNedeni | null;
  tarih: string;
}

export interface AuditLogEntry {
  id: string;
  islem_tipi: KullaniciIslemTipi;
  degisiklikler: Record<string, { eski: unknown; yeni: unknown }> | null;
  tarih: string;
  islem_yapan_id: string | null;
  islem_yapan_ad: string | null;
  islem_yapan_email: string | null;
}

export const getLoginHistory = (userId: string, params?: { limit?: number; offset?: number }) =>
  http.get<LoginHistoryEntry[]>(`${apiEndpoint}/${userId}/login-history`, { params });

export const getAuditLog = (userId: string, params?: { limit?: number; offset?: number }) =>
  http.get<AuditLogEntry[]>(`${apiEndpoint}/${userId}/audit-log`, { params });
